var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12 12 26.25 26.25",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#465D80",
    d: "M38.25,25.125C38.25,17.888,32.362,12,25.125,12S12,17.888,12,25.125S17.888,38.25,25.125,38.25 c3.195,0,6.125-1.15,8.403-3.054c0.033-0.024,0.061-0.051,0.089-0.081C36.447,32.705,38.25,29.124,38.25,25.125z M13.25,25.125 c0-6.548,5.327-11.875,11.875-11.875S37,18.577,37,25.125c0,3.31-1.364,6.305-3.556,8.461c-0.908-2.397-2.327-4.332-4.083-5.554 c0.972-1.076,1.502-2.486,1.471-3.952c-0.066-2.988-2.455-5.436-5.437-5.572c-1.581-0.091-3.071,0.484-4.21,1.572 c-1.14,1.087-1.767,2.554-1.767,4.128c0,1.417,0.531,2.782,1.472,3.824c-1.746,1.216-3.169,3.163-4.079,5.558 C14.616,31.433,13.25,28.437,13.25,25.125z M17.802,34.454c0.011-0.024,0.031-0.042,0.039-0.067 c0.88-2.519,2.361-4.506,4.169-5.593c0.217-0.129,0.362-0.355,0.388-0.605c0.025-0.251-0.071-0.503-0.262-0.677 c-0.933-0.843-1.468-2.048-1.468-3.305c0-1.229,0.49-2.375,1.38-3.224c0.888-0.849,2.04-1.272,3.289-1.229 c2.289,0.105,4.193,2.058,4.244,4.352c0.028,1.296-0.507,2.537-1.469,3.407c-0.188,0.172-0.285,0.424-0.26,0.675 c0.025,0.25,0.171,0.477,0.385,0.604c1.815,1.092,3.322,3.151,4.19,5.678C30.411,36.049,27.879,37,25.125,37 C22.361,37,19.822,36.043,17.802,34.454z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "none",
    stroke: "#465D80",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 25.125,
    cy: 25.125,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "none",
    stroke: "#465D80",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: " M33.168,34.694c-0.894-2.888-2.549-5.199-4.608-6.437c-0.103-0.062-0.115-0.201-0.026-0.282c1.054-0.953,1.706-2.342,1.672-3.883 c-0.058-2.637-2.205-4.841-4.84-4.962c-2.916-0.134-5.322,2.19-5.322,5.076c0,1.495,0.646,2.839,1.673,3.768 c0.089,0.081,0.077,0.22-0.026,0.282c-1.935,1.163-3.514,3.276-4.439,5.923"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-profile.4373242c.svg";
export { ForwardRef as ReactComponent };